import history from './history';

export const  getCurrentUser = (user) => {
    if(typeof user === "undefined" || user == null || user.userInfo == null || user.userInfo.roles == null || user.userInfo.permissions == null){
        return 
        history.push('/login-register');
    }
    
    if(user && user.userInfo){
        return {
            fullName : user.userInfo.name,
            email: user.userInfo.email,
            phoneNumber: user.userInfo.phone,
            photo: user.userInfo.photo,
            companyName: user.userInfo.company_name,
            jobTitle: user.userInfo.job_title,
            department: user.userInfo.department,
            customRates: user.userInfo.custom_rates,
            permissions: user.userInfo.permissions,
            role: user.userInfo.roles[0],
            token: user.userInfo.token,
            insurer:user.userInfo.insurer
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/user-utils.js